import React from "react";
import { Link } from "react-router-dom";
import { AiOutlineClockCircle, AiOutlineBarChart, AiOutlineTeam } from "react-icons/ai";
import { BsCalendarCheck } from "react-icons/bs";
import { MdOutlineWorkspaces } from "react-icons/md";

const LandingPage = () => {
  return (
      <div className="landing-shell">
        <section className="pt-24 px-4 sm:px-6 lg:px-8">
          <div className="max-w-7xl mx-auto py-20 text-center">
            <h1 className="text-4xl md:text-6xl font-bold text-theme-text mb-6">
              Effortless Time Tracking<br />
              <span className="text-brand-600">for Project Teams</span>
            </h1>
            <p className="text-xl text-theme-muted mb-8 max-w-2xl mx-auto">
              Track time, manage projects, and create timesheets with ease.
              Perfect for teams who want to boost productivity and streamline workflow.
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <Link to="/login" className="btn-primary px-8 py-3">
                Get Started
              </Link>
              <Link
                  to="/timesheetsthismonth"
                  className="btn-secondary px-8 py-3"
              >
                View Demo
              </Link>
            </div>
          </div>
        </section>

        <section className="py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-center text-theme-text mb-12">
              Key Features
            </h2>
            <div className="grid md:grid-cols-3 gap-8">
              <FeatureCard
                  icon={<AiOutlineClockCircle className="w-8 h-8" />}
                  title="Time Tracking"
                  description="Easy-to-use time tracking with start/stop timer or manual entry options"
              />
              <FeatureCard
                  icon={<BsCalendarCheck className="w-8 h-8" />}
                  title="Weekly Timesheets"
                  description="Automated timesheet generation with weekly and monthly views"
              />
              <FeatureCard
                  icon={<MdOutlineWorkspaces className="w-8 h-8" />}
                  title="Project Management"
                  description="Organize and track time across multiple projects efficiently"
              />
            </div>
          </div>
        </section>

        <section className="py-20 landing-section-alt">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-center text-theme-text mb-12">
              Why Choose Our Time Tracker?
            </h2>
            <div className="grid md:grid-cols-2 gap-8">
              <BenefitCard
                  icon={<AiOutlineBarChart className="w-6 h-6" />}
                  title="Increased Productivity"
                  description="Track and analyze time spent on tasks to optimize workflow and improve efficiency"
              />
              <BenefitCard
                  icon={<AiOutlineTeam className="w-6 h-6" />}
                  title="Team Collaboration"
                  description="Share timesheets and project progress with team members seamlessly"
              />
            </div>
          </div>
        </section>

        <section className="py-20 landing-cta">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl font-bold text-white mb-6">
              Ready to Start Tracking Time?
            </h2>
            <p className="text-indigo-100 mb-8 max-w-2xl mx-auto">
              Join thousands of professionals who trust our time tracking solution
            </p>
            <Link to="/signup" className="landing-cta-btn">
              Create Free Account
            </Link>
          </div>
        </section>
      </div>
  );
};

const FeatureCard = ({ icon, title, description }) => (
    <div className="landing-card">
      <div className="text-brand-600 mb-4">{icon}</div>
      <h3 className="text-xl font-semibold text-theme-text mb-2">{title}</h3>
      <p className="text-theme-muted">{description}</p>
    </div>
);

const BenefitCard = ({ icon, title, description }) => (
    <div className="flex items-start space-x-4">
      <div className="text-brand-600 bg-theme-accent p-3 rounded-lg">{icon}</div>
      <div>
        <h3 className="text-xl font-semibold text-theme-text mb-2">{title}</h3>
        <p className="text-theme-muted">{description}</p>
      </div>
    </div>
);

export default LandingPage;
